/* app/js/src/components/common/textarea/textarea.component.scss */
.cursor-pointer {
  cursor: pointer;
}
div label {
  color: #7d8fa1;
  text-transform: uppercase;
  margin-right: 5px;
  font-weight: normal;
  font-size: 0.85em;
  min-width: 90px;
  white-space: nowrap;
}
div textarea {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  border-radius: 4px;
  background-color: #ffffff;
  height: 30px;
  border: 1px solid #e1e6eb;
  line-height: 2.2em;
  font-size: 0.9em;
  padding: 0 15px;
  color: #232f3a;
}
div textarea:focus {
  border: 1px solid #aee5ff;
  outline: none;
}
div textarea::-webkit-input-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
div textarea:-moz-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
div textarea::-moz-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
div textarea:-ms-input-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
div textarea.ng-invalid.ng-dirty,
div textarea.ng-invalid.ng-touched {
  border-color: #ef5350;
}
div {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: flex-start;
  justify-content: flex-start;
  -webkit-align-items: baseline;
  -ms-flex-align: baseline;
  align-items: baseline;
  margin-bottom: 20px;
}
div label {
  -webkit-flex: 1 0 0;
  -ms-flex: 1 0 0;
  flex: 1 0 0;
}
div textarea {
  -webkit-flex: 5 0 0;
  -ms-flex: 5 0 0;
  flex: 5 0 0;
  height: auto;
  resize: none;
}
/*# sourceMappingURL=textarea.component.css.map */
